import { apis } from './factories'

export const gigBizApi = {
  apis,
}
